import { render, staticRenderFns } from "./right_sidebar.vue?vue&type=template&id=ae838fee&"
import script from "./right_sidebar.vue?vue&type=script&lang=js&"
export * from "./right_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports